import { render } from "./ReorderSurveyQuestionTypesView.vue?vue&type=template&id=0171d6dd&lang=pug"
import script from "./ReorderSurveyQuestionTypesView.vue?vue&type=script&lang=js"
export * from "./ReorderSurveyQuestionTypesView.vue?vue&type=script&lang=js"

import exportComponent from "/builds/mfar.technology/events/events-platform/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__